<template>
  <a-modal
    ref="createModal"
    title="新建生产异常记录"
    :width="900"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ x: 800, y: 260 }"
    >
      <span slot="completionDateTitle">
        <i class="toRequired">*</i>需求完成时间
      </span>
      <span slot="abnormalTypeTitle">
        <i class="toRequired">*</i>异常类型
      </span>
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.dataIndex === 'operation'">
            <a @click="handleDelete(typeList, record)">删除</a>
          </span>
          <span v-else-if="item.type === 'select'">
            <global-select
              :value.sync="record[item.dataIndex]"
              :selectType="item.selectType ? item.selectType : 'select'"
              :focusGet="item.focusGet ? item.focusGet : false"
              :requestApi="item.requestApi"
              :selectData="setArray(item.dataList)"
              :selectItem="{ value: item.value, label: item.label }"
              :searchParam="item.searchParam ? item.searchParam : ''"
              :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
              :allowClear="false"
              :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
              :sourseField="item.sourseField ? item.sourseField : ''"
              :dropdown-match-select-width="item.dropdownMatchSelectWidth === false ? false : true"
              @change="(val, selectList) => item.onChange ? item.onChange(val, selectList, record) : null"
            />
          </span>
          <span v-else-if="item.type === 'date'">
            <a-date-picker v-model="record[item.dataIndex]" />
          </span>
          <span v-else-if="item.type === 'dateTime'">
            <a-date-picker v-model="record[item.dataIndex]" show-time valueFormat="YYYY-MM-DD HH:mm:ss" />
          </span>
          <span v-else-if="item.type === 'input'">
            <a-input v-model="record[item.dataIndex]" :disabled="item.disabled ? true : false" />
          </span>
          <span v-else-if="item.type === 'inputNumber'">
            <a-input-number v-model="record[item.dataIndex]" :min="0" />
          </span>
        </div>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import { apiScpApsAbnormalityAdd } from '@/api/mes/basedata/anomalyRecord'
import cloneDeep from 'lodash.clonedeep'

export default {
  props: {
    inventOrg: {
      type: Array,
      default: () => {
        return []
      }
    },
    abnormalTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    pmcInformedFlagList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          title: '异常发现日期',
          dataIndex: 'abnormalityDiscoveredDate',
          scopedSlots: { customRender: 'abnormalityDiscoveredDate' },
          width: 170,
          type: "date"
        },
        {
          title: '加工组织',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode' },
          width: 180,
          type: "select",
          selectType: "selectAssemble",
          assembleLabel: true,
          dataList: 'inventOrg',
          value: 'realValue',
          label: 'label',
          dropdownMatchSelectWidth: false
        },
        {
          title: '车间说明',
          dataIndex: 'workshopCode',
          scopedSlots: { customRender: 'workshopCode' },
          width: 150,
          type: "select",
          focusGet: true,
          setParams: true,
          requestApi: '/bom/bomWorkshop/findList',
          value: 'workshopCode',
          label: 'workshopDesc',
          sourseField: "res"
        },
        {
          title: '产线说明',
          dataIndex: 'prodLineCode',
          scopedSlots: { customRender: 'prodLineCode' },
          width: 150,
          type: "select",
          focusGet: true,
          setParams: true,
          requestApi: '/bom/bomProdLine/findList',
          value: 'prodLineCode',
          label: 'prodLineDesc',
          sourseField: "res"
        },
        {
          title: '班组长',
          dataIndex: 'monitor',
          scopedSlots: { customRender: 'monitor' },
          width: 150,
          type: "input"
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          scopedSlots: { customRender: 'itemCode' },
          width: 150,
          type: "select",
          setParams: true,
          selectType: "selectAssembleSearch",
          focusGet: true,
          searchParam: "itemCode",
          requestApi: '/mes/mesDiscreteJobs/assemblyBox',
          value: 'selectedValue',
          label: 'bringOutDataOne',
          dropdownMatchSelectWidth: false
        },
        {
          title: '生产工单',
          dataIndex: 'job',
          scopedSlots: { customRender: 'job' },
          width: 150,
          type: "select",
          selectType: 'selectSearch',
          requestApi: "/mes/mesDiscreteJobs/allWipEntityName",
          value: 'realValue',
          label: 'label',
          searchParam: 'wipEntityName',
          dropdownMatchSelectWidth: false,
          setParams: true,
          ellipsis: true,
          onChange: (val, selectList, record) => {
            console.log(val, selectList, record)
            const tempSelectedItem = selectList.find(item => item.realValue === val)
            this.$set(record, 'orderNo', tempSelectedItem.bringOutDataOne)
          }
        },
        {
          title: '计划单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          width: 170,
          type: 'input',
          disabled: true,
          align: 'center',
          ellipsis: true
        },
        {
          // title: '异常类型',
          dataIndex: 'abnormalType',
          scopedSlots: { customRender: 'abnormalType', title: "abnormalTypeTitle" },
          width: 150,
          type: "select",
          dataList: 'abnormalTypeList',
          value: 'lookupCode',
          label: 'lookupValue'
        },
        {
          title: '异常原因说明',
          dataIndex: 'abnormalReason',
          scopedSlots: { customRender: 'abnormalReason' },
          width: 150,
          type: "input"
        },
        {
          title: '责任归属',
          dataIndex: 'liability',
          scopedSlots: { customRender: 'liability' },
          width: 200,
          type: "select",
          requestApi: "/system/lookup/data/likeList",
          value: 'lookupCode',
          label: 'lookupValue',
          setParams: true,
          selectType: 'selectMultipleSearch',
          searchParam: "lookupValue"
        },
        {
          title: '影响数量(套)',
          dataIndex: 'affectedQty',
          scopedSlots: { customRender: 'affectedQty' },
          width: 150,
          type: "inputNumber"
        },
        {
          title: '影响工时(时)',
          dataIndex: 'affectedWorkingHours',
          scopedSlots: { customRender: 'affectedWorkingHours' },
          width: 150,
          type: "inputNumber"
        },
        {
          title: '相关配合事项',
          dataIndex: 'relatedCoordinatedMatter',
          scopedSlots: { customRender: 'relatedCoordinatedMatter' },
          width: 150,
          type: "input"
        },
        {
          // title: '需求完成时间',
          width: 170,
          dataIndex: 'completionDate',
          scopedSlots: { customRender: 'completionDate', title: "completionDateTitle" },
          type: "dateTime"
        },
        {
          title: '实际完成时间',
          width: 170,
          dataIndex: 'actualCompletionDate',
          scopedSlots: { customRender: 'actualCompletionDate' },
          type: "dateTime"
        },
        {
          title: '状态',
          width: 150,
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          type: "select",
          requestApi: "/system/lookup/data/list",
          value: 'lookupCode',
          label: 'lookupValue',
          setParams: true
        },
        {
          title: '通知PMC',
          dataIndex: 'pmcInformedFlag',
          scopedSlots: { customRender: 'pmcInformedFlag' },
          width: 150,
          type: "select",
          dataList: 'pmcInformedFlagList',
          value: 'lookupCode',
          label: 'lookupValue'
        },
        {
          title: '操作',
          width: 60,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      typeList: [],
      statusList: []
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.getLookupList('APS_ABNORMAL_STATUS', 'statusList')
  },
  methods: {
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        abnormalityDiscoveredDate: this.$moment(new Date()).format('YYYY-MM-DD'),
        organizationCode: this.organizationCodeOrigin,
        workshopCode: "",
        prodLineCode: "",
        monitor: "",
        itemCode: "",
        job: "",
        abnormalType: "",
        abnormalReason: "",
        liability: [],
        affectedQty: "",
        affectedWorkingHours: "",
        relatedCoordinatedMatter: "",
        completionDate: "",
        actualCompletionDate: "",
        status: "NEW",
        pmcInformedFlag: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (this.typeList[i].affectedQty && Number(this.typeList[i].affectedQty) <= 0) {
          this.$message.warning('影响数量(套) 需大于0')
          flag = true
          return
        }
        if (this.typeList[i].affectedWorkingHours && Number(this.typeList[i].affectedWorkingHours) <= 0) {
          this.$message.warning('影响工时(时) 需大于0')
          flag = true
          return
        }
        if (!this.typeList[i].completionDate) {
          this.$message.warning('需求完成时间不能为空')
          flag = true
          return
        }
        if (!this.typeList[i].abnormalType) {
          this.$message.warning('异常类型不能为空')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      const tempParamsTypeList = cloneDeep(this.typeList)
      tempParamsTypeList.forEach(item => {
        if (Array.isArray(item.liability) && item.liability.length > 0) {
          item.liability = item.liability.join(',')
        } else {
          item.liability = ''
        }
      })
      apiScpApsAbnormalityAdd(tempParamsTypeList).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "workshopCode") {
        return { organizationCode: record.organizationCode }
      }
      if (dataIndex === "prodLineCode") {
        return { organizationCode: record.organizationCode }
      }
      if (dataIndex === "status") {
        return { lookupType: 'APS_ABNORMAL_STATUS' }
      }
      if (dataIndex === "itemCode") {
        return { organizationCode: record.organizationCode }
      }
      if (dataIndex === 'job') {
        return { organizationCode: record.organizationCode }
      }
      if (dataIndex === 'liability') {
        return { lookupType: 'MES_ABNORMAL_LIABILITY' }
      }
    },
    setArray (arr) {
      return this[arr]
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
input{
  width: 100%;
}
/deep/.ant-input-number{
  width: 100%;
}
/deep/.ant-select{
  width: 100%;
}
/deep/.ant-calendar-picker{
  min-width: 160px !important;
}
</style>
